"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "callWithCallback", {
  enumerable: true,
  get: function get() {
    return _callWithCallback["default"];
  }
});
Object.defineProperty(exports, "callWithPromise", {
  enumerable: true,
  get: function get() {
    return _callWithPromise["default"];
  }
});

var _callWithCallback = _interopRequireDefault(require("./callWithCallback"));

var _callWithPromise = _interopRequireDefault(require("./callWithPromise"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }